import React from 'react';

import { CustomSVGProps } from './CustomSVGProps.types';

export function IconGif48(props: CustomSVGProps): React.JSX.Element {
    return (
        <svg
            {...props}
            width="48"
            height="48"
            viewBox="0 0 48 48"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden={!props.onClick}
            aria-label="gif">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M1 23C1 21.3431 2.34315 20 4 20H35C36.6569 20 38 21.3431 38 23V33C38 34.6569 36.6569 36 35 36H4C2.34315 36 1 34.6569 1 33V23ZM4 22C3.44772 22 3 22.4477 3 23V33C3 33.5523 3.44772 34 4 34H35C35.5523 34 36 33.5523 36 33V23C36 22.4477 35.5523 22 35 22H4Z"
                fill={props.fill || 'currentColor'}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M9 5C9 2.23858 11.2386 0 14 0H32C32.2589 0 32.5078 0.100428 32.6941 0.280156L46.6941 13.7802C46.8896 13.9686 47 14.2285 47 14.5V43C47 45.7614 44.7614 48 42 48H14C11.2386 48 9 45.7614 9 43V35H11V43C11 44.6569 12.3431 46 14 46H42C43.6569 46 45 44.6569 45 43V15.5H34C32.3431 15.5 31 14.1569 31 12.5V2H14C12.3431 2 11 3.34315 11 5V21H9V5ZM33 3.35347L43.5223 13.5H34C33.4477 13.5 33 13.0523 33 12.5V3.35347Z"
                fill={props.fill || 'currentColor'}
            />
            <path
                d="M15.7423 27.668H17.5183V31.076C17.0623 31.42 16.5343 31.684 15.9343 31.868C15.3343 32.052 14.7303 32.144 14.1223 32.144C13.2503 32.144 12.4663 31.96 11.7703 31.592C11.0743 31.216 10.5263 30.7 10.1263 30.044C9.73431 29.38 9.53831 28.632 9.53831 27.8C9.53831 26.968 9.73431 26.224 10.1263 25.568C10.5263 24.904 11.0783 24.388 11.7823 24.02C12.4863 23.644 13.2783 23.456 14.1583 23.456C14.8943 23.456 15.5623 23.58 16.1623 23.828C16.7623 24.076 17.2663 24.436 17.6743 24.908L16.4263 26.06C15.8263 25.428 15.1023 25.112 14.2543 25.112C13.7183 25.112 13.2423 25.224 12.8263 25.448C12.4103 25.672 12.0863 25.988 11.8543 26.396C11.6223 26.804 11.5063 27.272 11.5063 27.8C11.5063 28.32 11.6223 28.784 11.8543 29.192C12.0863 29.6 12.4063 29.92 12.8143 30.152C13.2303 30.376 13.7023 30.488 14.2303 30.488C14.7903 30.488 15.2943 30.368 15.7423 30.128V27.668ZM19.3241 23.6H21.2681V32H19.3241V23.6ZM25.2056 25.16V27.38H29.0936V28.94H25.2056V32H23.2616V23.6H29.6096V25.16H25.2056Z"
                fill={props.fill || 'currentColor'}
            />
        </svg>
    );
}
